module.exports = __webpack_public_path__ + "img/apple_add_home_icon.7b0842b3.png";